import { useCallback, useEffect, useState } from "react";

export const useEmailConfirmed = (isEmailMeWhenAvailableProduct, id) => {
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(false);

  const handleEmailMeEvent = useCallback(
    (event) => {
      if (event.detail === id) {
        setIsEmailConfirmed(true);
      }
    },
    [id],
  );

  useEffect(() => {
    if (isEmailMeWhenAvailableProduct) {
      window.addEventListener("jl.emailMe.success", handleEmailMeEvent);
    }
    return () => {
      window.removeEventListener("jl.emailMe.success", handleEmailMeEvent);
    };
  }, [isEmailMeWhenAvailableProduct, handleEmailMeEvent]);

  return isEmailConfirmed;
};
